import { library } from '@fortawesome/fontawesome-svg-core'

import {faCog} from '@fortawesome/free-solid-svg-icons/faCog'
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe'
import {faUserCog} from '@fortawesome/free-solid-svg-icons/faUserCog'
import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown'
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons/faSignInAlt'
import {faUserShield} from '@fortawesome/free-solid-svg-icons/faUserShield'
import {faShieldAlt} from '@fortawesome/free-solid-svg-icons/faShieldAlt'
import {faArrowDown} from '@fortawesome/free-solid-svg-icons/faArrowDown'
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faInfo} from '@fortawesome/free-solid-svg-icons/faInfo'
import {faBullhorn} from '@fortawesome/free-solid-svg-icons/faBullhorn'
import {faBan} from '@fortawesome/free-solid-svg-icons/faBan'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons/faExclamationCircle'

import {faDropbox} from '@fortawesome/free-brands-svg-icons/faDropbox'
import {faGoogleDrive} from '@fortawesome/free-brands-svg-icons/faGoogleDrive'
import {faYandexInternational} from '@fortawesome/free-brands-svg-icons/faYandexInternational'

library.add(
    faCog,
    faSignOutAlt,
    faGlobe,
    faUserCog,
    faSortDown,
    faBars,
    faTimes,
    faAngleRight,
    faAngleLeft,
    faSignInAlt,
    faUserShield,
    faShieldAlt,
    faArrowDown,
    faTrashAlt,
    faPlus,
    faInfo,
    faBullhorn,
    faBan,
    faCheck,
    faTimes,
    faSpinner,
    faDropbox,
    faGoogleDrive,
    faYandexInternational,
    faCheckCircle,
    faExclamationCircle,
)

export default {
    library,
}
